import { Switch } from "antd";
import { PicCenterOutlined } from "@ant-design/icons";
import { Handle, Position } from "reactflow";

import { ButtonDelete } from "../ButtonDelete";
import { useFlowNodes } from "../../context";

import "./DefaultResponseNode.scss";

const DefaultResponseNode = (props) => {
  const { id } = props;
  const { t, setNodes, setEdges, updateElement, updateIntent, intent } =
    useFlowNodes();

  const handleDelete = () => {
    updateIntent?.((prev) => ({
      ...prev,
      is_default: false,
    }));
  };

  return (
    <>
      <Handle type="target" position={Position.Top} id="main" />
      <div className="default-response-node">
        <div className="header-aligned">
          <span className="icon-root-badge">
            <PicCenterOutlined />
          </span>

          <div className="header-title-wrapper">
            <span className="header-title">
              {t("common:intents.options.switch.is_default.title")}
            </span>
          </div>

          <div className="delete-button">
            <ButtonDelete
              setNodes={setNodes}
              setEdges={setEdges}
              nodeId={id}
              onClick={handleDelete}
              position={Position.Top}
              handleDelete={handleDelete}
            />
          </div>
        </div>

        <div className="intent-separator" />

        <div className="switch-wrapper">
          <Switch
            checked={intent.is_default ? intent.is_default : false}
            onClick={(e) => {
              updateElement(e, "is_default", "bool");
            }}
          />
        </div>
      </div>
    </>
  );
};

export default DefaultResponseNode;
